import React, { createContext, useState, useEffect, useCallback } from "react";
import { supabase } from "./supabaseClient";

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isRecoveryFlow, setIsRecoveryFlow] = useState(false);

  const fetchUserData = useCallback(async (authUser) => {
    const { data, error } = await supabase
      .from("users_data")
      .select("position, name, last_name, number")
      .eq("user_uid", authUser.id)
      .single();

    if (error) {
      console.error("Error fetching user data:", error);
      setUser({
        id: authUser.id,
        email: authUser.email,
        role: null,
        name: authUser.email,
      });
    } else {
      setUser({
        id: authUser.id,
        email: authUser.email,
        role: data.position,
        name: [data.name, data.last_name].filter(Boolean).join(" ").trim() || authUser.email,
        number: data.number,
      });
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) {
        fetchUserData(session.user);
      } else {
        setLoading(false);
      }
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (_event === 'PASSWORD_RECOVERY') {
        setIsRecoveryFlow(true);
        setSession(session);
        setLoading(false);
        return;
      }
      setSession(session);
      if (session) {
        fetchUserData(session.user);
      } else {
        setUser(null);
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, [fetchUserData]);

  const login = useCallback(async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) {
      return { success: false, error: error.message };
    }
    return { success: true, data };
  }, []);

  const logout = useCallback(async () => {
    await supabase.auth.signOut();
    setUser(null);
    setSession(null);
  }, []);

  const userPosition = user?.role || null;

  return (
    <SessionContext.Provider value={{ user, session, loading, userPosition, login, logout, isRecoveryFlow, setIsRecoveryFlow }}>
      {children}
    </SessionContext.Provider>
  );
};
